import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { adStickerService } from '@/services/adStickerService';

export function useAdStickers() {
  const client = useQueryClient();
  const refresh = () => client.invalidateQueries({ queryKey: ['ad-stickers'] });
  const query = useQuery({ queryKey: ['ad-stickers'], queryFn: adStickerService.list });
  const create = useMutation({
    mutationFn: ({ name, imageUrl }: { name: string; imageUrl: string }) => adStickerService.create(name, imageUrl),
    onSuccess: refresh,
  });
  const rename = useMutation({
    mutationFn: ({ id, name }: { id: string; name: string }) => adStickerService.rename(id, name),
    onSuccess: refresh,
  });
  const remove = useMutation({ mutationFn: adStickerService.remove, onSuccess: refresh });
  return { query, create, rename, remove };
}
